export const navigation = [
  {
    "label": "Dashboard",
    "link": "/dashboard",
    "icon": "MdDashboard"
  },
  {
    "label": "Profiling",
    "link": "/profiling",
    "icon": "AiOutlineProfile",
    "subItems": [
      {
        "label": "Raw Data",
        "link": "/profiling",
        "icon": "MdOutlinePendingActions"
      },
      {
        "label": "Verified",
        "link": "/verified-data",
        "icon": "MdOutlineVerifiedUser"
      },
    ]
  },
  {
    "label": "Leads",
    "link": "/leads",
    "icon": "MdOutlineLeaderboard"
  },
  {
    "label": "Customers",
    "link": "/customers",
    "icon": "FaUsers"
  },
  {
    "label": "Sales",
    "link": "/sales",
    "icon": "LiaSellsy",
    "subItems": [
      {
        "label": "Proposals",
        "link": "/proposals",
        "icon": "PiNotebookLight"
      },
      {
        "label": "Invoices",
        "link": "/invoices",
        "icon": "PiNotebookLight"
      },
      {
        "label": "Credit Notes",
        "link": "/credit-notes",
        "icon": "PiNotebookLight"
      },
      {
        "label": "Payments",
        "link": "/payments",
        "icon": "PiNotebookLight"
      },
    ]
  },
  {
    "label": "Purchase",
    "link": "/purchase",
    "icon": "CiBadgeDollar",
    "subItems": [
      {
        "label": "Vendors",
        "link": "/purchase-vendors",
        "icon": "MdCardMembership"
      },
      {
        "label": "Orders",
        "link": "/purchase-orders",
        "icon": "MdCardMembership"
      },
      {
        "label": "Invoices",
        "link": "/purchase-invoices",
        "icon": "MdCardMembership"
      },
      {
        "label": "Credit Notes",
        "link": "/purchase-credit-notes",
        "icon": "MdCardMembership"
      },
      {
        "label": "Payments",
        "link": "/purchase-payments",
        "icon": "MdCardMembership"
      },
    ]
  },

  {
    "label": "Users",
    "link": "/users",
    "icon": "FaUsers",
    "subItems": [
      // {
      //   "label": "Permission",
      //   "link": "/permission",
      //   "icon": "AiFillLock"
      // },
      {
        "label": "Role",
        "link": "/role",
        "icon": "RiShieldUserFill"
      },
      {
        "label": "User",
        "link": "/user",
        "icon": "FaRegUser"
      },
    ]
  },

  {
    "label": "Items",
    "link": "/items",
    "icon": "MdOutlineShoppingBag",
    "subItems": [
      {
        "label": "Products",
        "link": "/products",
        "icon": "MdOutlineInventory"
      },
      {
        "label": "Categories",
        "link": "/categories",
        "icon": "MdCategory"
      },
      {
        "label": "Support Plans",
        "link": "/support",
        "icon": "MdSupportAgent",
        "subItems": [
          {
            "label": "Group",
            "link": "/groups",
            "icon": "MdGroupWork"
          },
          {
            "label": "Checklist",
            "link": "/checklists",
            "icon": "VscChecklist"
          },
          {
            "label": "Plans",
            "link": "/plans",
            "icon": "IoPaperPlaneOutline"
          },
        ]
      },
    ]
  },
  // {
  //   "label": "Support Plans",
  //   "link": "/support",
  //   "icon": "MdSupportAgent",
  //   "subItems": [
  //     {
  //       "label": "Group",
  //       "link": "/groups",
  //       "icon": "MdGroupWork"
  //     },
  //     {
  //       "label": "Checklist",
  //       "link": "/checklists",
  //       "icon": "VscChecklist"
  //     },
  //     {
  //       "label": "Plans",
  //       "link": "/plans",
  //       "icon": "IoPaperPlaneOutline"
  //     },
  //   ]
  // },
  {
    "label": "Feedback",
    "link": "/feedback",
    "icon": "MdOutlineFeedback",
    "subItems": [
      {
        "label": "Link",
        "link": "/feedback-links",
        "icon": "FaLink"
      },
      {
        "label": "Feedbacks",
        "link": "/feedbacks",
        "icon": "VscChecklist"
      },
      {
        "label": "Settings",
        "link": "/feedback-settings",
        "icon": "IoSettingsOutline"
      },
    ]
  },

  {
    "label": "Tasks",
    "link": "/tasks",
    "icon": "MdTaskAlt"
  },
  {
    "label": "Tickets",
    "link": "/tickets",
    "icon": "BsClipboard2"
  },

  {
    "label": "Field Visits",
    "link": "/field-visits",
    "icon": "MdLocationPin"
  },
  {
    "label": "Renewals",
    "link": "/renewals",
    "icon": "LuRefreshCw"
  },

  {
    "label": "Configurations",
    "icon": "GrDocumentConfig",
    "subItems": [
      {
        "label": "Localization",
        "link": "/localization",
        "icon": "MdOutlineLanguage"
      },
      {
        "label": "Tax",
        "link": "/tax",
        "icon": "IoNewspaperOutline"
      },
      {
        "label": "Currency",
        "link": "/currency",
        "icon": "GrCurrency"
      },
      {
        "label": "General Settings",
        "link": "/general-settings",
        "icon": "IoSettingsOutline"
      },
      {
        "label": "Module Settings",
        "link": "/module-settings",
        "icon": "VscFileSubmodule"
      },
      {
        "label": "Departments",
        "link": "/departments",
        "icon": "RiOrganizationChart"
      },
      {
        "label": "Designations",
        "link": "/designations",
        "icon": "RiUserStarLine"
      },
      {
        "label": "System Logs",
        "link": "/system-logs",
        "icon": "MdHistory"
      }
    ]
  }
]
